import { Slider, SliderProps } from "@mui/material";
import { Control, FieldPath, FieldValues, useController } from "react-hook-form";

export function RangeSliderContent<T extends FieldValues>({
    control,
    minName,
    maxName,
    min,
    max,
    step,
    ...sliderElementProps
}: SliderProps & {
    control: Control<T>;
    minName: FieldPath<T>;
    maxName: FieldPath<T>;
}) {
    const { field: minField } = useController({
        control,
        name: minName,
        rules: {
            min,
            max,
        },
    });

    const { field: maxField } = useController({
        control,
        name: maxName,
        rules: {
            min,
            max,
        },
    });

    return (
        <Slider
            value={[minField.value ?? min ?? 0, maxField.value ?? max ?? 100]}
            onChange={(_event, newValue) => {
                if (Array.isArray(newValue)) {
                    minField.onChange(newValue[0]);
                    maxField.onChange(newValue[1]);
                }
            }}
            disableSwap
            min={min}
            max={max}
            step={step}
            {...sliderElementProps}
        />
    );
}
